import {
  LOCAL_STORAGE_ACTIVE_SESSION_TAB,
  LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT,
  SESSION_STORAGE_TAB_ID
} from "../constantsObservacions";
import { obtenirToken } from "./gestioWebToken";

const HEARTBEAT_TTL_MS = 2 * 60 * 1000;

const generateTabId = () => {
  return `${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
};

export const getCurrentTabId = () => {
  let tabId = sessionStorage.getItem(SESSION_STORAGE_TAB_ID);
  if (!tabId) {
    tabId = generateTabId();
    sessionStorage.setItem(SESSION_STORAGE_TAB_ID, tabId);
  }
  return tabId;
};

export const markSessionForCurrentTab = () => {
  localStorage.setItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB, getCurrentTabId());
  localStorage.setItem(
    LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT,
    `${Date.now()}`
  );
};

export const refreshSessionHeartbeat = () => {
  const activeTabId = localStorage.getItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB);
  if (activeTabId !== getCurrentTabId() || !obtenirToken()) {
    return;
  }

  localStorage.setItem(
    LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT,
    `${Date.now()}`
  );
};

export const clearSessionForCurrentTab = () => {
  const activeTabId = localStorage.getItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB);
  if (activeTabId === getCurrentTabId()) {
    localStorage.removeItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB);
    localStorage.removeItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT);
  }
};

const clearActiveSessionLock = () => {
  localStorage.removeItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB);
  localStorage.removeItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT);
};

export const hasSessionInAnotherTab = () => {
  if (!obtenirToken()) {
    return false;
  }

  const activeTabId = localStorage.getItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB);
  if (!activeTabId) {
    return false;
  }

  if (activeTabId === getCurrentTabId()) {
    refreshSessionHeartbeat();
    return false;
  }

  const heartbeat = Number(
    localStorage.getItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT)
  );
  const heartbeatIsValid = Number.isFinite(heartbeat);
  const isHeartbeatExpired =
    !heartbeatIsValid || Date.now() - heartbeat > HEARTBEAT_TTL_MS;

  if (isHeartbeatExpired) {
    clearActiveSessionLock();
    return false;
  }

  return true;
};
